(function () {
    'use strict';

    angular.module("imApp").factory("srFollowUpsService", ['$ihttp', function ($ihttp) {
        var service = {
            getSrFollowUps: function (parms) {
                return $ihttp.post({
                    method: 2128,
                    parameters: parms || {}
                });
            },
            listSrFollowUps: function (parms) {
                return $ihttp.post({
                    method: 2129,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();